<template>
    <div class="box mt-5">
        <p class="">{{translate('new_software_intro')}}</p>
        <form v-on-valid-form="submitForm" v-if="!isSent" class="relative">
            <div class="grid grid-cols-2 mobile:grid-cols-1 gap-5 mt-4">
                <div>
                    <label for="name">{{translate('last_name')}}*</label>
                    <input id="name"  type="text" v-model="form.name" v-validate.required="translate('last_name')"/>
                </div>
                <div>
                    <label for="company_name">{{translate('company_name')}}*</label>
                    <input id="company_name" type="text" v-model="form.companyName" v-validate.required="translate('company_name')" />
                </div>
                <div>
                    <label for="email">{{translate('email')}}*</label>
                    <input id="email"  type="email" v-model="form.email" v-validate.required.email="translate('email')" />
                </div>
                <div>
                    <label for="phone">{{translate('phone')}}</label>
                    <div class="flex gap-2">
                        <div class="shrink">
                            <select id="phone_country" v-model="form.phoneCountry" class="min-w-20">
                                <option value="BE">+32</option>
                                <option value="NL">+31</option>
                                <option value="FR">+33</option>
                                <option value="LU">+352</option>
                                <option value="DE">+49</option>
                                <option value="GB">+44</option>
                            </select>
                        </div>
                        <input id="phone" type="tel" v-model="form.phone" />
                    </div>
                            
                </div>
                <div class="col-span-2">
                    <label for="softwareName">{{translate('name_software')}}*</label>
                    <input id="softwareName"  type="text" v-model="form.softwareName" v-validate.required="translate('name_software')"  />
                </div>
                <div class="col-span-2">
                    <label>&nbsp;</label>
                    <button type="submit" class="btn btn-primary block">{{translate('button_send')}}</button>
                </div>
            </div>
            <input type="text" class="absolute invisible -z-10" v-model="form.honey" />
        </form>
        <p v-else class="mt-8">
            {{translate("thank_you_message")}}
        </p>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import Ajax from "../../../lib/Ajax";
import store from "parchment/src/attributor/store";

export default defineComponent({
    name: "new-software",
    computed: {
        store() {
            return store
        }
    },
    props: {
        
    },
    data() {
        return {
            form: {
                honey: '',
                email: window.cw.email ?? "",
                phoneCountry: window.cw.phoneCountry ?? "BE", //Do brand check here when Integrations get enabled in LIZA?
                phone: window.cw.phone ?? "",
                companyName: window.cw.customerName ?? "",
                name: window.cw.name ?? "",
                softwareName: ''
            },
            isSent: false
        }
    },
    methods: {
        async submitForm(): Promise<void> {
            if (!!this.form.honey)
                return;

            await Ajax.postAsync("/ajax/integrations/new-software", {...this.form});

            this.isSent = true;

        }
    },
})
</script>